<template>
    <div id="app" class="rtl">
        <nav class="navbar navbar-expand-lg sticky-top navbar-dark bg-secondary">
            <!--<img src="./assets/img/logotype_white.svg" class="img-fluid" style="max-width: 150px">-->
            <h3 class="text-nowrap" style="max-width: 250px">{{companyName}}</h3>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <!--<li class="nav-item p-lg-0 p-md-0 p-sm-5" :class="{active: $route.name === 'home'}" data-toggle="collapse"-->
                    <!--data-target="#navbarNav" v-if="!logOut">-->
                    <!--<router-link to="/" class="nav-link f-sz-08rem">{{companyName}}</router-link>-->
                    <!--</li>-->
                    <li class="nav-item p-lg-0 p-md-0 p-sm-5" :class="{active: $route.name === 'home'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut">
                        <router-link to="/" class="nav-link f-sz-08rem">
                            خانه
                        </router-link>
                        <!--<a class="nav-link" href="/">خانه <span class="sr-only">(current)</span></a>-->
                    </li>
                    <li class="nav-item" :class="{active: $route.name === 'selectCustomer'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut && companyPostName !== 'تامین کننده'">
                        <router-link to="/selectCustomer" class="nav-link f-sz-08rem">
                            فروش
                        </router-link>
                    </li>
                    <li class="nav-item"
                        :class="{active: $route.name === 'buy' || $route.name === 'buy-from-outsource'}"
                        data-toggle="collapse" data-target="#navbarNav" v-if="!logOut  && companyPostName !== 'فروشنده'">
                        <router-link to="/buy" class="nav-link f-sz-08rem">
                            خرید
                        </router-link>
                    </li>
                    <!--<li class="nav-item"-->
                    <!--:class="{active: $route.name === 'buy' || $route.name === 'buy-from-outsource'}"-->
                    <!--data-toggle="collapse" data-target="#navbarNav" v-if="!logOut">-->
                    <!--<router-link to="/production" class="nav-link f-sz-08rem">-->
                    <!--تولید-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav-item" :class="{active: $route.name === 'products'}">-->
                    <!--<router-link to="/products" class="nav-link">-->
                    <!--محصولات-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav-item" :class="{active: $route.name === 'archives'}" data-toggle="collapse"-->
                    <!--data-target="#navbarNav">-->
                    <!--<router-link to="/archives" class="nav-link">-->
                    <!--بایگانی-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <!--<li class="nav-item" :class="{active: $route.name === 'headlines'}" data-toggle="collapse"-->
                    <!--data-target="#navbarNav">-->
                    <!--<router-link to="/headlines" class="nav-link">-->
                    <!--سرفصل ها-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <li class="nav-item" :class="{active: $route.name === 'transactions'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut && companyPostName !== 'تامین کننده' && (companyPostName === 'مدیر' || companyPostName === 'صندوق دار')">
                        <router-link to="/transactions" class="nav-link f-sz-08rem">
                            دریافت-پرداخت
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{active: $route.name === 'reports'}" data-toggle="collapse"
                        v-if="(companyPostName === 'مدیر' ||companyPostName === 'صندوق دار' || companyPostName === 'تامین کننده' )&& !logOut "
                        data-target="#navbarNav">
                        <router-link to="/reports" class="nav-link f-sz-08rem">
                            گزارشات
                        </router-link>
                    </li>
                    <!--<li class="nav-item" :class="{active: $route.name === 'initial-balance'}">-->
                    <!--<router-link to="/initial-balance" class="nav-link">-->
                    <!--موجودی اولیه-->
                    <!--</router-link>-->
                    <!--</li>-->
                    <li class="nav-item" :class="{active: $route.name === 'todayCheck'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut && companyPostName !== 'تامین کننده'&& (companyPostName === 'مدیر' || companyPostName === 'صندوق دار')">
                        <router-link to="/todayCheck" class="nav-link f-sz-08rem">
                            چکها
                            {{checkCount}}
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{active: $route.name === 'inventoryLessProduct'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut && companyPostName !== 'تامین کننده'">
                        <router-link to="/inventoryLessProduct" class="nav-link f-sz-08rem">
                            کسری ها
                            {{lessProduct}}
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{active: $route.name === 'saleMali'}" data-toggle="collapse"
                        data-target="#navbarNav" v-if="!logOut && companyPostName !== 'تامین کننده' && saleMali!== null">
                        <router-link to="/saleMali" class="nav-link f-sz-08rem">
                            {{saleMali}}
                        </router-link>
                    </li>
                </ul>
                <ul class="navbar-nav ml-auto">

                    <li class="nav-item d-none d-lg-block" :class="{active: $route.name === 'settings'}">
                        <router-link to="/settings" class="nav-link" data-toggle="tooltip" data-placement="bottom"
                                     title="تنظیمات">
                            <i class="fa fa-cog"></i>
                        </router-link>
                    </li>
                    <li class="nav-item d-none d-lg-block" :class="{active: $route.name === 'select-store'}">
                        <router-link to="/select-store" class="nav-link" data-toggle="tooltip" data-placement="bottom"
                                     title="انتخاب فروشگاه">
                            <i class="fa fa-cart-arrow-down"></i>
                        </router-link>
                    </li>
                    <li class="nav-item d-none d-lg-block" :class="{active: $route.name === 'profile'}">
                        <router-link to="/profile" class="nav-link" data-toggle="tooltip" data-placement="bottom"
                                     title="پروفایل">
                            <i class="fa fa-user-o"></i>
                        </router-link>
                    </li>
                    <li class="nav-item d-none d-lg-block" :class="{active: $route.name === 'support'}">
                        <router-link to="/support" class="nav-link" data-toggle="tooltip" data-placement="bottom"
                                     title="راهنما و پشتیبانی">
                            <i class="fa fa-headphones"></i>
                        </router-link>
                    </li>
                    <li class="nav-item d-none d-lg-block" @click="logout">
                        <div class="nav-link" data-toggle="tooltip" data-placement="bottom"
                             title="خروج">
                            <i class="fa fa-power-off"></i>
                        </div>
                    </li>
                    <li class="nav-item d-lg-none" :class="{active: $route.name === 'settings'}" data-toggle="collapse"
                        data-target="#navbarNav">
                        <router-link to="/settings" class="nav-link f-sz-08rem">
                            تنظیمات
                        </router-link>
                    </li>
                    <li class="nav-item d-lg-none" :class="{active: $route.name === 'select-store'}"
                        data-toggle="collapse" data-target="#navbarNav">
                        <router-link to="/select-store" class="nav-link f-sz-08rem">
                            انتخاب فروشگاه
                        </router-link>
                    </li>
                    <li class="nav-item d-lg-none" :class="{active: $route.name === 'profile'}" data-toggle="collapse"
                        data-target="#navbarNav">
                        <router-link to="/profile" class="nav-link f-sz-08rem">
                            پروفایل
                        </router-link>
                    </li>
                    <li class="nav-item d-lg-none" :class="{active: $route.name === 'support'}" data-toggle="collapse"
                        data-target="#navbarNav">
                        <router-link to="/support" class="nav-link f-sz-08rem">
                            پشتیبانی
                        </router-link>
                    </li>

                    <li class="nav-item d-lg-none" @click="logout" data-toggle="collapse" data-target="#navbarNav">
                        <div class="nav-link f-sz-08rem">
                            خروج
                        </div>
                    </li>
                </ul>
                <toggle-button id="changed-font" class="m-0 ml-5" :color="{checked: '#00c853', unchecked: '#90a4ae'}"
                               data-toggle="collapse" data-target="#navbarNav"
                               :value="listView" :sync="true" :labels="{checked: 'لیست', unchecked: 'بلوک'}" :width="65"
                               @change="onChangeEventHandler"/>
            </div>
        </nav>
        <div class="container-fluid">
            <transition
                    name="fade"
                    mode="out-in"
            >
                <router-view/>
            </transition>
        </div>
    </div>
</template>

<script>
    import EventBus from './_framework/event-bus.js';
    import * as $ from "jquery";
    import BaseService from "./_framework/api/BaseService";
    import Utils from "./_framework/utils/Utils";

    export default {
        data() {
            return {
                listView: false,
                companyName: "",
                checkCount: "",
                lessProduct: "",
                saleMali: "",
                queryParams: {
                    pageSize: 9,
                    pageIndex: 0,
                    type: 1,
                    outsourceType: 13
                },
                companyPostName: "",
                logOut: false,
            }
        },
        mounted() {
            this.companyPostName = localStorage.getItem("companyPostName");
            this.listView = JSON.parse(localStorage.getItem("listView"));
            this.companyName = localStorage.getItem("companyName");
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            });
            let theme = localStorage.getItem("theme");
            if (theme !== null) {
                $("body").addClass(theme);
            } else {
                $("body").addClass("default");
            }
            EventBus.$on('theme', value => {
                $("body").removeClass().addClass(value);
            });
            EventBus.$on('companyNameChange', value => {
                this.companyName = value;
            });
            EventBus.$on('checkCountChange', value => {
                this.checkCount = value;
            });
            EventBus.$on('lessProductChange', value => {
                this.lessProduct = value;
            });
            EventBus.$on('companyPostNameChange', value => {
                this.companyPostName = value;
            });
           EventBus.$on('saleMaliChange', value => {
                this.saleMali = value;
            });
            EventBus.$on('logOut', value => {
                this.logOut = value;
            });
            this.checkCount = "";
            new BaseService('account', '/GetActiveSalemali').getList().then(response => {
                if (response.data != null && response.data !== undefined && response.data !== '') {
                    this.saleMali = response.data.name;
                    EventBus.$emit('saleMaliChange', response.data.name);
                    localStorage.setItem("salemali_start" , response.data.startDate);
                    localStorage.setItem("salemali_end" , response.data.endDate);
                }else{
                    EventBus.$emit('saleMaliChange', null);
                    localStorage.setItem("salemali_start" , null);
                    localStorage.setItem("salemali_end" ,null);
                }

            }).catch(error => {
                EventBus.$emit('saleMaliChange', null);
                localStorage.setItem("salemali_start" , null);
                localStorage.setItem("salemali_end" ,null);
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            new BaseService('reports', '/GetTodayCheckReport').getList(this.queryParams).then(response => {
                if (response.data != null && response.data !== undefined && response.data !== '') {
                    this.checkCount = "(" + response.data.count + ")";
                }

            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            new BaseService('reports', '/GetTodayCheckReport').getList(this.queryParams).then(response => {
                if (response.data != null && response.data !== undefined && response.data !== '') {
                    this.checkCount = "(" + response.data.count + ")";
                }

            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
        },
        methods: {
            onChangeEventHandler(e) {
                EventBus.$emit('listView', e.value);
                if (e.value === true) {
                    localStorage.setItem("listView", "true");
                } else {
                    localStorage.setItem("listView", "false");
                }
            },
            logout() {
                if (confirm("آیا میخواهید خارج شوید؟")) {
                    localStorage.removeItem("phoneNumber");
                    localStorage.removeItem("token_mobile");
                    localStorage.removeItem("isRegistered");
                    localStorage.removeItem("auth_token");
                    localStorage.removeItem("userId");
                    localStorage.removeItem("companyId");
                    localStorage.removeItem("companyName");
                    localStorage.removeItem("companyPostName");
                    localStorage.removeItem("company_usersId");
                    localStorage.removeItem("company_usersName");
                    localStorage.removeItem("API_BASE_URL");
                    localStorage.removeItem("BASE_URL");
                    EventBus.$emit('companyNameChange', "");
                    EventBus.$emit('logOut', true);
                    this.$router.push({
                        name: 'login',
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '~vuejs-noty/dist/vuejs-noty.css';
    @import "assets/styles/custom.scss";

    .noty-body {
        text-align: right !important;
        font-family: 'Shabnam', Tahoma, sans-serif;
    }

    #nav {
        padding: 30px;
        a {
            font-weight: bold;
            font-size: 0.8rem;
            color: #2c3e50;
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .f-sz-08rem {
        font-size: 0.8rem;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s ease;
    }

    .fade-enter, .fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .vue-js-switch .v-switch-label.v-left {
        line-height: 24px !important;
    }

    .vue-js-switch#changed-font {
        font-size: 0.75rem;
    }
</style>
